export default __webpack_public_path__ + "static/media/dodawanie-paczki-4.b60e7432.png";